import { render, staticRenderFns } from "./BaseNoItemBanner.vue?vue&type=template&id=38ecf332&scoped=true&"
import script from "./BaseNoItemBanner.vue?vue&type=script&lang=js&"
export * from "./BaseNoItemBanner.vue?vue&type=script&lang=js&"
import style0 from "./BaseNoItemBanner.vue?vue&type=style&index=0&id=38ecf332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ecf332",
  null
  
)

export default component.exports